import React, {Component} from 'react';
import './App.css';
import ReactGA from 'react-ga';


import {BrowserRouter as Router,Route,Redirect,Switch} from 'react-router-dom';
import ProductListingPageContainer from '../Components/ProductListingPage/ProductListingPageContainer/ProductListingPageContainer';
import HomePageContainer from '../Components/HomePage/HomePageContainer/HomePageContainer';
import PageNotFound from '../Components/PageNotFoundContainer/PageNotFound';

import Navigation from '../Components/MainHeader/Navigation';
import ProductDetailPageContainer from '../Components/PDP/ProductDetailPageContainer';
import PagesContainer from '../Components/Pages/PagesContainer';
import BlogPageContainer from '../Components/BlogPageContainer/BlogPageContainer';
import BlogListingPageContainer from '../Components/BlogListingPage/BlogListingPageContainer/BlogListingPageContainer';
import { createBrowserHistory } from 'history';
let history = createBrowserHistory();

ReactGA.initialize('UA-146439432-1');


history.listen(location => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
})

class App extends Component {

  componentDidMount() {
		ReactGA.pageview(window.location.pathname)
	} 

  render (){    
   
    return (
      <Router history={history}>
        <Navigation/>
          <Switch>
          <Route  path="/blog" exact={true}> <BlogListingPageContainer/> </Route>
            <Route  path="/blog/:blogId" exact={true}> <BlogPageContainer/> </Route>
            <Route  path="/page/:pageId" exact={true}> <PagesContainer/> </Route>
            <Route  path="/" exact={true}> <HomePageContainer/> </Route>
            <Route  path="/category/:category" exact={true} > <ProductListingPageContainer/> </Route>
            <Route  path="/search/:searchTerm" > <PageNotFound/> </Route>
            <Route  path="/:category/:productId/" exact={true} > <ProductDetailPageContainer/> </Route>
            <Route  path="/404" exact={true}> <PageNotFound/> </Route>
            
            <Redirect to="/404"/> 
          </Switch>
      </Router>      

    );      
    
    }
  }

export default App;
